'use client'

import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { AN_TRUONG_IMAGES } from './an-truong.constants'

export const StorySection = () => {
  const t = useTranslations('landing_an_truong.story')

  return (
    <section className='w-full bg-[#f8f8f8] px-4 py-12 lg:px-[60px] lg:py-[120px]'>
      <div className='grid grid-cols-1 items-center gap-7 lg:grid-cols-12 lg:gap-20'>
        {/* Copy column (6 cols on desktop) */}
        <div className='order-2 flex flex-col items-start gap-3.5 lg:order-1 lg:col-span-6 lg:gap-5'>
          <h2 className='font-criteria text-[28px] font-semibold leading-[41px] tracking-[-0.56px] text-neutral-900 lg:text-[44px] lg:leading-[60px] lg:tracking-[-0.88px]'>
            {t.rich('title', {
              br: () => <br />,
            })}
          </h2>

          <p className='font-sans text-base leading-6 text-neutral-700 lg:text-lg'>
            {t('desc_1')}
          </p>

          <p className='font-sans text-base font-bold leading-6 text-neutral-700 lg:text-lg'>
            {t('desc_2')}
          </p>
        </div>

        {/* Media column (6 cols on desktop) */}
        <div className='relative order-1 aspect-[343/280] w-full overflow-hidden rounded-xl lg:order-2 lg:col-span-6 lg:aspect-[900/640] lg:h-auto'>
          <Image
            src={AN_TRUONG_IMAGES.story.videoPlaceholder}
            alt='An Trương × Coolmate'
            fill
            sizes='(max-width: 1024px) 100vw, 50vw'
            className='pointer-events-none object-cover'
          />
        </div>
      </div>
    </section>
  )
}
